import React, { useState, useRef } from "react"
import FileUpload from './file_upload';

export default function NewDocumentForm({clients, document, url, auto_process, renewal_id, return_to}) {
  const [isDragging, setIsDragging] = useState(false);
  const [files, setFiles] = useState(null);

  const filePresent = files && files.length > 0;
  const csrfToken = globalThis.document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  const clientSpecified = typeof(document.client_id) == "string" && document.client_id.length > 0;
  const fileTypeSpecified = typeof(document.file_type) == "string" && document.file_type.length > 0;

  return (
    <form id="new_document" action={url} method="post" encType="multipart/form-data" className="w-full">
      <input type="hidden" name="authenticity_token" value={csrfToken} autoComplete="off" />
      {auto_process && <input autocomplete="off" type="hidden" name="document[auto_process]" value={auto_process} />}
      {renewal_id && <input autocomplete="off" type="hidden" name="renewal_id" value={renewal_id} />}
      {return_to && <input autocomplete="off" type="hidden" name="return_to" value={return_to} />}
      <div className="space-y-8">
        <div>
          <label htmlFor="document_file" className="block text-gray-700 text-sm font-bold mb-2">File</label>
          <FileUpload
            htmlId="document_file"
            htmlName="document[file]"
            className="min-h-32 flex items-center justify-center text-center text-wrap"
            onChange={(files) => setFiles(files)}
          />
        </div>
        <div>
          <label htmlFor="document_file_type" className={`block text-sm font-bold mb-2 ${fileTypeSpecified ? 'text-gray-500' : 'text-gray-700'}`}>File Type</label>
          <select id="document_file_type" name="document[file_type]" defaultValue={document.file_type} className={`shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none ${fileTypeSpecified ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : 'bg-white text-gray-700 focus:shadow-outline'}`} readonly={fileTypeSpecified ? "readonly" : null}>
            <option value="Booklet">Booklet</option>
            <option value="Contract">Contract</option>
            <option value="Renewal">Renewal</option>
            <option value="Claims Experience">Claims Experience</option>
            <option value="Claims Experience Breakdown">Claims Experience Breakdown</option>
            <option value="Billing Statement">Billing Statement</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div>
          <label htmlFor="document_client_id" className={`block text-sm font-bold mb-2 ${clientSpecified ? "text-gray-500" : "text-gray-700"}`}>Group</label>
          <select id="document_client_id" name="document[client_id]" defaultValue={document.client_id} className={`shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none ${clientSpecified ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : 'bg-white text-gray-700 focus:shadow-outline'}`} readonly={clientSpecified ? "readonly" : null}>
            <option value="">None</option>
            {
              clients.map(client => (
                <option key={client.id} value={client.id}>{client.name}</option>
              ))
            }
          </select>
        </div>
        <div>
          <input
            type="submit"
            name="commit"
            value={auto_process ? "Upload and extract" : "Upload"}
            className={"button button__primary" + (filePresent ? "" : " button__disabled")}
            disabled={filePresent ? null : "disabled"}
          />
        </div>
      </div>
    </form>
  )
}
